import { BLOCK_PADDING, uid } from "../create-shared";
import type { TextBlock, TextVariant } from "../types";
import type { BlockDefinition } from "./types";

export const TEXT_PLACEHOLDERS: Record<TextVariant, string> = {
  normal: 'Add your text here',
  h1: 'Your heading',
  h2: 'Your subheading',
  h3: 'Section title',
  h4: 'Subsection title',
  h5: 'Small heading',
  h6: 'Label heading',
};

export const TEXT_VARIANT_STYLE: Record<
  TextVariant,
  { fontSize: number; fontWeight: number; lineHeight: number }
> = {
  normal: { fontSize: 16, fontWeight: 400, lineHeight: 1.5 },
  h1: { fontSize: 28, fontWeight: 700, lineHeight: 1.25 },
  h2: { fontSize: 22, fontWeight: 700, lineHeight: 1.3 },
  h3: { fontSize: 18, fontWeight: 700, lineHeight: 1.35 },
  h4: { fontSize: 16, fontWeight: 700, lineHeight: 1.4 },
  h5: { fontSize: 14, fontWeight: 700, lineHeight: 1.45 },
  h6: { fontSize: 12, fontWeight: 700, lineHeight: 1.5 },
};

export const TEXT_VARIANT_OPTIONS: { value: TextVariant; label: string }[] = [
  { value: 'normal', label: 'Paragraph' },
  { value: 'h1', label: 'Heading 1' },
  { value: 'h2', label: 'Heading 2' },
  { value: 'h3', label: 'Heading 3' },
  { value: 'h4', label: 'Heading 4' },
  { value: 'h5', label: 'Heading 5' },
  { value: 'h6', label: 'Heading 6' },
];

export function createTextBlock(
  variant: TextVariant = 'normal',
  html?: string,
): TextBlock {
  const style = TEXT_VARIANT_STYLE[variant];
  return {
    id: uid(),
    type: 'text',
    variant,
    html: html ?? TEXT_PLACEHOLDERS[variant],
    align: 'left',
    fontSize: style.fontSize,
    fontWeight: style.fontWeight,
    lineHeight: style.lineHeight,
    padding: { ...BLOCK_PADDING },
  };
}

export const textBlockDefinition: BlockDefinition = {
  type: 'text',
  label: 'Text',
  create: () => createTextBlock(),
};
